import React from 'react';
import FormInput from "../../common/form/form_input";
import {Link, Redirect} from "react-router-dom";
import FormErrorMessage from "../../common/form/form_error_message";
import InfoCardClusterLogin from "../../main/component/info-cards/info-card--cluster-login";
import {_t} from "../../../js/app/common/utils/locale";
import Visible from "../../../js/app/main/app/component/common/visible";
import Message from "../../common/message";

export default function render(props) {
    if (this.state.redirect) {
        return (
            <Redirect to={this.state.redirect} />
        );
    }

    return (
        <section className="section section-cluster-form section-cluster-login">
            <section className="cluster-form-card login-card login-card__login">

                <InfoCardClusterLogin />

                <div className="cluster-form-card__body login-card__form">
                    <header className="cluster-form-card__header">
                        <h2 className="title title--h2">{_t('Reset password')}</h2>
                    </header>

                    <Message message={this.state.message} />

                    <FormErrorMessage message={this.state.error_message} />

                    <Visible visible={!this.props.cluster}>
                        <FormInput
                            name={'cluster'}
                            label={'Cluster login'}
                            onChange={this.onChangeInput.bind(this)}
                            errors={this.state.errors.cluster}
                            labelClass="cluster-login"
                        />
                    </Visible>
                    <FormInput
                        name={'login'}
                        label={'User login'}
                        onChange={this.onChangeInput.bind(this)}
                        errors={this.state.errors.login}
                        labelClass="user-login"
                    />

                    <div className="btn-bar">
                        <button className="btn btn--alt btn__login" onClick={this.onSubmit.bind(this)}>{_t('Reset password')}</button>
                        <Link to="/" className="link link--primary link--bold btn__reg">{_t('Login')}</Link>
                    </div>
                </div>

            </section>
        </section>
    );
};